import React from "react"
import { Table, Button } from "semantic-ui-react"
import AseComments from "./AseComments"
import RetailPrice from "./RetailPrice"
import { displayField, displayCurrency } from "../../../utils/utils"
import { sortByAttr } from "../../../helpers/arrayHelpers"
import { PRICE_REVIEW, AWAITING_APPROVAL, PAID_STATUSES } from '../../../constants/orders'

export default class NotesTab extends React.Component {
  state = {
    aseCommentsUpdates: {}
  }

  updateAseComments = () => {
    const orderServiceArray = this.props.order_services.map((orderService) => {
      const updatedOS = {...orderService}

      if (this.state.aseCommentsUpdates[updatedOS.id]) {
        updatedOS.ase_comments = this.state.aseCommentsUpdates[updatedOS.id]
      }
      return updatedOS
    })

    this.props.updateOrder({ order_services: orderServiceArray, status: AWAITING_APPROVAL })
  }

  updateRetailPrice = () => {
    const orderServiceArray = this.props.order.order_services.map((orderService) => {
      const updatedOS = {...orderService}

      if (this.state.retailPriceUpdates[updatedOS.id]) {
        updatedOS.retail_price = this.state.retailPriceUpdates[updatedOS.id]
      }
      return updatedOS
    })

    this.props.updateOrder({ order_services: orderServiceArray })
  }

  onSaveRetailPrice(price, os) {
    let osRetailPrice = {...this.state.retailPriceUpdates}
    osRetailPrice[os.id] = price && price.replace(/[^\d\.]/gi, "")
    this.setState({ retailPriceUpdates: osRetailPrice })
  }

  onSaveComment(newComment, os) {
    let orderServiceAseComments = {...this.state.aseCommentsUpdates}
    orderServiceAseComments[os.id] = newComment
    this.setState({aseCommentsUpdates: orderServiceAseComments})
  }

  shopPrice(os) {
    if (os.ai_details) {
      const price = this.aiTotal(os)
      return <p>${price.toFixed(2)}</p>
    } else return "--"
  }

  aiTotal(os) {
    return os.ai_details
      .map(d => d.extendedPrice)
      .reduce((acc, piece) => (acc += parseFloat(piece)), 0)
  }

  priceDifferential(os) {
    if (os.override_total && os.ai_details) {
      const difference = (os.override_total - this.aiTotal(os)).toFixed(2)
      let percDiff = 0
      if (os.override_total > 0)
        percDiff = ((difference * 100) / os.override_total).toFixed(0)

      let color = "black"

      if (percDiff > 50) color = "red"
      else if (percDiff > 25) color = "orange"
      else if (percDiff > 0) color = "green"

      return (
        <p>
          ${difference < 0 && "("}
          {Math.abs(difference)}
          {difference < 0 && ")"}{" "}
          <span style={{ color: color }}>(%{percDiff})</span>
        </p>
      )
    } else return "--"
  }

  totalfiedOrderServices() {
    const { orderServices } = this.props
    const selected = orderServices.filter(
      os => ["Deleted", "Saved"].indexOf(os.status) === -1
    )
    return sortByAttr(orderServices, 'name_with_position').concat([
      {
        name_with_position: "Total",
        status: "--",
        override_total: selected.reduce(
          (acc, os) => (acc += parseFloat(os.override_total) || 0),
          0
        ),
        ai_details: selected.reduce(
          (acc, os) =>
            os.ai_details ? acc.concat(os.ai_details) : acc.concat([]),
          []
        ),
        hideEdit: true
      }
    ])
  }

  render() {
    const { order, orderServices } = this.props

    return (
      <React.Fragment>
        {orderServices.length === 0 && (
          <div>
            <em>No services</em>
          </div>
        )}
        {orderServices.length !== 0 && (
          <Table
            striped
            celled
            selectable
            style={{ marginTop: "1em", marginBottom: "5px" }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Override Total</Table.HeaderCell>
                {PAID_STATUSES.includes(order.status) &&
                  <Table.HeaderCell>Retail Price</Table.HeaderCell>
                }
                <Table.HeaderCell>Shop's Estimate Price</Table.HeaderCell>
                {order.is_fixed_price && (
                  <React.Fragment>
                    <Table.HeaderCell>Shop's Price</Table.HeaderCell>
                    <Table.HeaderCell>Price Differential</Table.HeaderCell>
                  </React.Fragment>
                )}
                {order.status === PRICE_REVIEW && (
                  <Table.HeaderCell>Ase Comments</Table.HeaderCell>
                )}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.totalfiedOrderServices().map(os => {
                const {
                  name_with_position,
                  status,
                  override_total,
                  shop_price_estimate,
                  retail_price,
                  ase_comments,
                  hideEdit = false
                } = os
                return (
                  <Table.Row key={`orderService-id-${os.id}`}>
                    <Table.Cell>
                      {displayField(name_with_position)}
                    </Table.Cell>
                    <Table.Cell>{displayField(status)}</Table.Cell>
                    <Table.Cell>
                      {displayCurrency(override_total)}
                    </Table.Cell>
                    {PAID_STATUSES.includes(order.status) &&
                      <Table.Cell>
                        {hideEdit ?
                          <Button
                            style={{ marginTop: "10px" }}
                            type="button"
                            size='mini'
                            color='orange'
                            onClick={this.updateRetailPrice}
                          >
                            Submit
                          </Button>
                        :
                          <RetailPrice
                            onSave={(value) => this.onSaveRetailPrice(value, os)}
                            retailPrice={retail_price}
                          />
                        }
                      </Table.Cell>
                    }
                    <Table.Cell>
                      {displayCurrency(shop_price_estimate)}
                    </Table.Cell>
                    {order.is_fixed_price && (
                      <React.Fragment>
                        <Table.Cell>{this.shopPrice(os)}</Table.Cell>
                        <Table.Cell>
                          {this.priceDifferential(os)}
                        </Table.Cell>
                      </React.Fragment>
                    )}
                    {order.status === PRICE_REVIEW && (
                      <Table.Cell>
                        <AseComments
                          isFixedPrice={order.is_fixed_price}
                          onSave={(value) => this.onSaveComment(value, os)}
                          hideEdit={hideEdit}
                          aseComments={displayField(ase_comments)}
                          onSubmit={this.updateAseComments}
                        />
                      </Table.Cell>
                    )}
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
        )}
      </React.Fragment>
    )
  }
}
